import { blue, orange } from "@mui/material/colors";
var white = '#FFFFFF';
var black = '#000000';
export default {
    mode: 'light',
    primary: {
        contrastText: "#FFF",
        dark: '#0b7452',
        main: '#10a676',
        light: '#3fb791',
    },
    secondary: {
        contrastText: '#76808D',
        dark: '#338c58',
        main: '#4AC97E',
        light: '#6ed397',
    },
    success: {
        contrastText: white,
        dark: '#388e3c',
        main: "#66bb6a",
        light: '#81c784'
    },
    info: {
        contrastText: white,
        dark: blue[900],
        main: blue[600],
        light: blue[400]
    },
    warning: {
        contrastText: white,
        dark: orange[900],
        main: orange[600],
        light: orange[400]
    },
    error: {
        contrastText: white,
        dark: "#d32f2f",
        main: "#f44336",
        light: "#e57373"
    },
    background: {
        default: '#FFFFFF',
        paper: '#EDEDED',
    }
};
